import { createContext, useEffect, useState, useCallback, useMemo } from 'react';
import { fetchUserAttributes } from 'collaboration-sidebar/api/UserSettings';
import { getUserAttributesArray } from '../constants/userAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_STATE = {
  loading: true,
  error: null,
  settings: undefined
};
export const UserSettingsContext = /*#__PURE__*/createContext(Object.assign({}, INITIAL_STATE, {
  setState: () => {}
}));
export default function UserSettingsProvider({
  children,
  objectId
}) {
  const [state, setState] = useState(INITIAL_STATE);
  const fetchUserSettings = useCallback(() => {
    if (!objectId) {
      return;
    }
    setState({
      loading: true,
      error: null
    });
    const keysToFetch = getUserAttributesArray();
    fetchUserAttributes(keysToFetch).then(payload => {
      const settingsArr = Object.keys(payload).reduce((acc, key) => {
        acc.push({
          key,
          value: payload[key]
        });
        return acc;
      }, []);
      setState({
        loading: false,
        error: null,
        settings: settingsArr
      });
    }).catch(error => {
      setState({
        loading: false,
        error,
        settings: undefined
      });
    });
  }, [objectId]);
  useEffect(() => {
    fetchUserSettings();
  }, [fetchUserSettings]);
  const userSettingsState = useMemo(() => Object.assign({}, state, {
    setState
  }), [state]);
  return /*#__PURE__*/_jsx(UserSettingsContext.Provider, {
    value: userSettingsState,
    children: children
  });
}